import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { EducationLevelFilterOptionValue, FilterOptionInformation } from '@studyportals/search-filters';

class EducationLevelFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.EDUCATION_LEVEL,
			[
				new FilterOptionInformation('Bachelor', EducationLevelFilterOptionValue.BACHELOR, '', ''),
				new FilterOptionInformation('Master', EducationLevelFilterOptionValue.MASTER, '', ''),
				new FilterOptionInformation('PhD', EducationLevelFilterOptionValue.PHD, '', ''),
				new FilterOptionInformation('Short Course', EducationLevelFilterOptionValue.SHORT_COURSE, '', '')
			],
			[]
		);
	}
}

export default new EducationLevelFilterDefinition();
